import React from 'react';
import BubbleNavigation from '../BubbleUI/BubbleNavigation';
import { useActiveProperty } from '@go-client/context/ActivePropertyContext';
import {
  resolveTranslationsPath,
  TRANSLATIONS_SUBNAV_LIBRARY,
  TRANSLATIONS_SUBNAV_OTHERS,
  TRANSLATIONS_SUBNAV_TYPE,
} from '@go-client/routes';

export default function TranslationsNavigation(props: { active: TRANSLATIONS_SUBNAV_TYPE }) {
  const { activeProperty: property } = useActiveProperty();

  return (
    <BubbleNavigation
      items={[
        {
          name: 'Lib. Translations',
          to: resolveTranslationsPath(property._id, 'events'),
          active: TRANSLATIONS_SUBNAV_LIBRARY.includes(props.active),
          variant: 'titanium',
        },
        {
          name: 'Brand Translations',
          to: resolveTranslationsPath(property._id, 'segments'),
          active: TRANSLATIONS_SUBNAV_OTHERS.includes(props.active),
          variant: 'titanium',
        },
      ]}
    />
  );
}
